<template>
  <ul class="car-color-picker flex items-center gap-6 px-1.5">
    <li
      v-for="option in options"
      :key="option.name"
      :title="option.name"
    >
      <input
        :id="`colorId-${option.name}`"
        v-model="computedModel"
        :value="option.name"
        type="radio"
        aria-hidden="true"
        class="hidden peer"
      >
      <label
        :for="`colorId-${option.name}`"
        :style="{ backgroundColor: option.hex}"
        :class="{'is-active': isActive(option.name as string)}"
        class="car-color-picker__option"
      />
    </li>
  </ul>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { CarColor } from '~/types';

interface Props extends /* @vue-ignore */ Partial<HTMLInputElement> {
  options: CarColor[]
  modelValue?: string | number | null
}

// eslint-disable-next-line func-call-spacing
const emit = defineEmits<{
  (event: 'update:modelValue', payload: string | number): void;
}>();

const props = defineProps<Props>();
function isActive (id: string | number): boolean {
  return String(props?.modelValue) === String(id);
}

const computedModel = computed({
  get () {
    return props.modelValue;
  },
  set (newValue: any) {
    emit('update:modelValue', newValue);
  },
});
</script>

<style scoped>
.car-color-picker__option {
  @apply rounded-full cursor-pointer lg:size-10 size-6 block border-brand-primary/20 border outline-4 outline-white outline transition-shadow duration-300 peer-checked:ring-6 peer-checked:ring-black;
}
</style>
